import { Pipe, PipeTransform } from '@angular/core';
import { I18nService } from './i18n.service';

// {{ 'shell.help' | translate }} or {{ 'overview.subtitle' | translate:{month: monthLabel} }}
//
// Impure so it re-evaluates when the language toggle changes lang$ — a pure
// pipe would keep showing the language that was active when the view was
// first rendered, since neither the key string nor the params object it
// receives change when only the service's current language does.
@Pipe({ name: 'translate', pure: false })
export class TranslatePipe implements PipeTransform {
  constructor(private i18n: I18nService) { }

  transform(key: string, params?: { [k: string]: string | number }): string {
    return this.i18n.t(key, params);
  }
}
